<template>
  <div class="facebook-login-page">
    <Preloader class="preloader-facebook-login" :showPreloader="true"/>
  </div>
</template>
<style scoped lang="sass"></style>
<script>

import {mapActions} from "vuex"
import Preloader from "../../components/Preloader/Preloader.vue"
export default {
  name: "GoogleLogin",
  data() {
    return {}
  },
  components: {
    Preloader
  },
  methods: {
    ...mapActions(['setAuthSuccess', 'details']),
    getCookie(name) {
      let matches = document.cookie.match(new RegExp(
          "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
      ));
      return matches ? decodeURIComponent(matches[1]) : undefined;
    },
  },
  created() {
    localStorage.setItem('token', this.getCookie('access_token'))
    this.setAuthSuccess(this.getCookie('access_token'))
    this.details()
        .then(res => {
          this.$router.push('/my-gates')
        })
  }
}
</script>